module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = [];\nvar price = model.rentalPriceFormatted;\nvar preventSubText = false;\nif(!((model.rentalPrice || 0) * 1)){\nprice = 'auf Anfrage'\npreventSubText = true;\n}\n// console.log(model.rentalPrice, model.rentalPriceFormatted, '=>', price);\n%>\n<div class=\"<%- additionalClasses.join(' '); %>\">\n<h3>Preis</h3>\n<div>\n<p>Mietpreis: <b><%= price %></b></p>\n<% if(!preventSubText) { %>\n<p class=\"small\">Brutto inklusive Betriebskosten</p>\n<% } %>\n</div>\n</div>"
  , __filename = "components/templates/project/gallery/pricing.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = [];
var price = model.rentalPriceFormatted;
var preventSubText = false;
if(!((model.rentalPrice || 0) * 1)){
price = 'auf Anfrage'
preventSubText = true;
}
// console.log(model.rentalPrice, model.rentalPriceFormatted, '=>', price);

    ; __line = 10
    ; __append("\n<div class=\"")
    ; __line = 11
    ; __append( additionalClasses.join(' ') )
    ; __append("\">\n<h3>Preis</h3>\n<div>\n<p>Mietpreis: <b>")
    ; __line = 14
    ; __append(escapeFn( price ))
    ; __append("</b></p>\n")
    ; __line = 15
    ;  if(!preventSubText) { 
    ; __append("\n<p class=\"small\">Brutto inklusive Betriebskosten</p>\n")
    ; __line = 17
    ;  } 
    ; __append("\n</div>\n</div>")
    ; __line = 19
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/project/gallery/pricing.ejs

}